module.exports = __webpack_public_path__ + "img/success.d29f1779.svg";